import { styled } from "@mui/material";

export const StyledServices = {
  Root: styled("section")(({ theme }) => ({
    position: "relative",
    paddingBlock: "clamp(72px, 10vw, 128px)",
    background: theme.palette.background.soft,
  })),

  Grid: styled("div")({
    marginTop: "clamp(40px, 5vw, 60px)",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 24,
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  }),

  Card: styled("div")(({ theme }) => ({
    position: "relative",
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    borderRadius: theme.custom.radius.lg,
    padding: "34px 30px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    transition:
      "transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: theme.custom.shadow.md,
      borderColor: "rgba(23, 79, 155, 0.28)",
    },
    "&:hover .glow": { opacity: 0.16 },
  })),

  Glow: styled("div")(({ theme }) => ({
    position: "absolute",
    top: -60,
    right: -60,
    width: 180,
    height: 180,
    borderRadius: "50%",
    background: theme.custom.gradient.brand,
    filter: "blur(50px)",
    opacity: 0,
    transition: "opacity 0.4s ease",
  })),

  Icon: styled("div")(({ theme }) => ({
    width: 56,
    height: 56,
    display: "grid",
    placeItems: "center",
    borderRadius: 16,
    color: "#fff",
    background: theme.custom.gradient.brand,
    boxShadow: "0 12px 26px -12px rgba(23, 79, 155, 0.75)",
    "& svg": { fontSize: "1.6rem" },
  })),

  Title: styled("h3")(({ theme }) => ({
    marginTop: 22,
    fontFamily: theme.custom.fonts.display,
    fontWeight: 700,
    fontSize: "1.32rem",
    color: theme.palette.text.primary,
  })),

  Summary: styled("p")(({ theme }) => ({
    marginTop: 12,
    color: theme.custom.colors.textSoft,
    fontSize: "0.98rem",
  })),

  List: styled("ul")(({ theme }) => ({
    listStyle: "none",
    padding: 0,
    margin: "22px 0 26px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    flex: 1,
    "& li": {
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: "0.94rem",
      color: theme.palette.text.primary,
    },
    "& li svg": {
      flexShrink: 0,
      color: "#2E9BD9",
      background: "rgba(46, 155, 217, 0.12)",
      borderRadius: "50%",
      padding: 3,
      width: 20,
      height: 20,
    },
  })),

  Link: styled("a")(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontFamily: theme.custom.fonts.display,
    fontWeight: 600,
    fontSize: "0.95rem",
    color: theme.custom.colors.indigo600,
    alignSelf: "flex-start",
    cursor: "pointer",
    "& svg": { transition: "transform 0.25s ease", fontSize: "1.1rem" },
    "&:hover svg": { transform: "translate(3px, -3px)" },
  })),

  Pro: styled("div")(({ theme }) => ({
    marginTop: 32,
    display: "grid",
    gridTemplateColumns: "1fr 1.1fr",
    gap: 30,
    alignItems: "center",
    padding: "clamp(30px, 4vw, 46px)",
    borderRadius: theme.custom.radius.lg,
    background: `linear-gradient(135deg, ${theme.custom.colors.navy900}, ${theme.custom.colors.navy700})`,
    color: "#fff",
    overflow: "hidden",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(500px 300px at 100% 0%, rgba(75,163,224,0.18), transparent 60%)",
      pointerEvents: "none",
    },
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  })),

  ProHead: styled("div")(({ theme }) => ({
    position: "relative",
    "& h3": {
      color: "#fff",
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "clamp(1.4rem, 2.5vw, 1.9rem)",
    },
    "& p": { marginTop: 12, color: "rgba(255,255,255,0.7)" },
  })),

  ProList: styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    position: "relative",
    "& li": {
      display: "flex",
      alignItems: "center",
      gap: 11,
      fontWeight: 500,
      fontSize: "0.96rem",
    },
    "& li svg": {
      flexShrink: 0,
      color: "#06172F",
      background: "#8AC2EC",
      borderRadius: "50%",
      padding: 4,
      width: 22,
      height: 22,
    },
    "@media (max-width: 560px)": { gridTemplateColumns: "1fr" },
  }),
};
